// src/pages/GroupChatPage.js

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GroupChatInterface from '../features/chat/views/GroupChatInterface';
import Page from '../components/Page';
import '../styles/GroupChatPage.css';

const GroupChatPage = () => {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBack = () => {
    navigate('/groups');
  };

  // If the route is malformed, show a simple error; otherwise let the interface handle loading/errors inline
  if (!groupId) {
    return (
      <Page width="default" className="error-container">
        <p className="error-message">{t('chat.load_error')}</p>
        <button className="back-button" onClick={handleBack}>
          {t('common.back')}
        </button>
      </Page>
    );
  }

  // Pass the known id; GroupChatInterface renders the shell immediately and manages data loading inline
  // key={groupId} ensures full remount on group switch - no state leakage
  return (
    <Page width="default" className="group-chat-page">
      <GroupChatInterface key={groupId} groupId={groupId} initialGroup={{ id: groupId }} onBack={handleBack} />
    </Page>
  );
};

export default GroupChatPage;
